import L, { LatLngExpression } from 'leaflet';
import { SortTypeOptions } from 'src/app/components/CountriesInformationComponent/countries-infomations.config';
import { MapInstance } from 'src/app/redux/map/map.redux.type';
import { InterestsTypes } from 'src/enums/interests.enum';
import { EnterpriseRelationsResultType } from 'src/types/enterprise.type';
import { LocationsColumnDataType } from 'src/types/table.type';

export enum MarkerClassNames {
  lastLocationClassEnum = 'last-location-icon',
  defaultMarkerClassEnum = 'default-marker-icon',
  previousLocationClassEnum = 'previous-location-icon',
}

export type LeafletEventsType = {
  onDrawCompleted: (e: L.DrawEvents.Created) => void;
};

// const iconHtml = ({ divClass, imgClass, src }: { divClass: string; imgClass: string; src: string }) =>
//   `<div class="${divClass}"><img class="${imgClass}" src="${src}"/></div>`;

export const customMarkers = {
  lastLocation: (className: string) =>
    L.icon({
      iconUrl: '/markers/lastLocation.png',
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      className,
    }),
  defaultMarker: (className: string) =>
    L.icon({
      iconUrl: '/markers/location.png',
      iconSize: [20, 32],
      iconAnchor: [10, 32],
      className,
    }),
  previousLocations: (className: string) =>
    L.icon({
      iconUrl: '/markers/previousLocations.png',
      iconSize: [34, 34],
      iconAnchor: [17, 34],
      className,
    }),
};

export const submarkerClassNameGenerator = (id: string, number: number) => {
  return `sub-${id}-${number}`;
};

export const subMarkerClassNameParser = (subId: string) => {
  const parts = subId.split('-');
  parts.pop();
  return parts.join('-');
};
export interface ILeafletMapProps {
  mapOptions?: L.MapOptions;
  drawOptions?: L.Control.DrawConstructorOptions;
  elements?: any;
  events?: LeafletEventsType;
  lastCoordinates?: {
    latitude: number | null;
    longitude: number | null;
  }[];
  interestIdentifiedLocations?: {
    lat: number;
    lng: number;
    id: string;
    interestType: InterestsTypes;
    time: number;
    blockID: string;
    label?: string;
  }[];
  mapId: MapInstance;
  style: React.CSSProperties;
  generalMapViewProps?: GeneralMapViewProps;
  onMapRendered?: () => void;
  isDashboard?: boolean;
}
export interface GeneralMapViewProps {
  mapColor: [string, string];
  addedSupplierCountries?: EnterpriseRelationsResultType['from']['rows'];
  addedCountries?: LocationsColumnDataType[];
  sortBy?: SortTypeOptions;
  actionOnClick?: (selectedCountry: EnterpriseRelationsResultType['from']['rows'] | LocationsColumnDataType) => void;
}

export interface InterestLocation {
  id: string;
  coordinates: [number, number];
  // marker: L.Marker<any>;
  viewSubs: boolean;
  marker: L.Marker<any>;
  time: number;
  blockID: string;
  // time: number;
  subMarkers?: {
    coordinates: [number, number];
    // marker: L.Marker<any>;
  }[];
  polyLine?: {
    polyLineMarker: L.Polyline<any>;
    coordinates: LatLngExpression[];
  };
  color?: string;
  label?: string;
}
export const markerGenerator = (
  coordinates: [number, number],
  label: string,
  map: L.Map,
  icon: L.DivIcon,
  id?: string,
) => {
  const newMarkerToAdd = L.marker([...coordinates], {
    // @ts-ignore
    id,
    icon,
  });
  // newMarkerToAdd.bindPopup(`<div style={{padding: "1em}}>
  // <p>${label}</p>
  // <p>${coordinates.map((coordinate) => coordinate.toFixed(6)).join(", ")}</p>
  //   </div>`);
  return newMarkerToAdd;
};

export interface CustomMarker {
  id: string;
  marker: L.Marker<any>;
  coordinates: number[];
  time: number;
  blockID: string;
  label?: string;
  prime?: boolean;
}
export interface OverLappedInterests {
  overlappedArray: CustomMarker[];
  x: number;
  y: number;
}
export interface ActionState {
  id: string;
  count: number;
}

export interface FeaturesFromBackend {
  type: string;
  properties: {
    name: string;
    ISO_A3: string;
    alphaCode: string | undefined;
  };
  geometry: {
    type: string;
    coordinates: [][];
  };
}
